import { memo, Suspense } from 'react';
import { lazyRetry } from '@utils/lazyRetry';

const QuickPanelWrapper = lazyRetry(() =>
  import('@/components/theme-layouts/components/quickPanel/QuickPanel').then((module) => ({
    default: () => (
      <Suspense>
        <module.default />
      </Suspense>
    )
  }))
);

function RightSideLayout1() {
  return <QuickPanelWrapper />;
}

export default memo(RightSideLayout1);
